import {
  computed,
  ref,
  toRef,
} from "vue";

export default function CsvAPI(props) {
  const csvOptions = toRef(props, "csvOptions");
  const id = toRef(props, "id");
  const url = toRef(props, "url");

  const csvOptionsLocal = ref({});

  const csvOptionsComputed = computed(() => {
    if (csvOptions.value) {
      return csvOptions.value;
    }
    return csvOptionsLocal.value;
  });

  const csvId = computed(() => {
    return `${ id.value }_csv`;
  });

  const updateCsvOptionsLocal = ({ response, urlParams }) => {
    csvOptionsLocal.value = {
      url: url.value,
      status: response.csv_available,
      csv_max_entries: response.csv_max_entries,
      title: `Suchergebnis als CSV-Datei herunterladen ${ response.csv_max_entries ? ` (maximal ${ response.csv_max_entries } Datensätze)` : "" }`,
      params: urlParams,
      label: "",
    };
  };

  return {
    csvId,
    csvOptionsComputed,
    updateCsvOptionsLocal,
  };
}
